import { HeroCardDirective } from './hero-card.directive';
import { HeroCtaDirective } from './hero-cta.directive';

export const Directives = [
	HeroCardDirective,
	HeroCtaDirective,
];
